<template>
  <component
    :is="layout"
    :favorites="favorites"
    :currentLang="currentLang"
    :menus="visibleMenus"
    :customMenus="customMenus"
    :customTabs="customTabs"
    :menusActiveID="menusActiveID"
    :panes="panes"
    :panesHistory="panesHistory"
    :activeKey="activeKey"
    :unfold="unfold"
    :subjectMode="subjectMode"
    @menuschange="handleMenusChange"
    @menuchange="handleMenuChange"
    @addcustommenu="handleCustomMenuAdd"
    @removecustommenu="handleCustomMenuRemove"
    @editcustommenu="handleCustomMenuEdit"
    @menupushpin="handleMenuPushpin"
  >
    <template v-slot:rightContentRender>
      <right-content :subjectMode="subjectMode" />
    </template>

    <!-- 正常页面展示 -->
    <router-view v-if="$route.meta.routerView && ['home', 'entry401'].includes(activeKey)" />

    <!-- IFRAME -->
    <template v-for="iframe in iframes">
      <iframe
        v-show="iframe.key === activeKey"
        :id="iframe.key"
        :key="iframe.key"
        :src="iframeUrl(iframe)"
        width="100%"
        height="100%"
        frameborder="0"
      />
    </template>

    <!-- 子应用容器 -->
    <template v-for="(app, index) in microApps.filter(app => app.name)">
      <div
        v-show="$route.params.name === app.name"
        :id="`${serviceId}-${systemCode}-${app.name}-view-box`"
        :key="index"
      />
    </template>
    <!-- 自定义弹框 -->
    <a-modal v-model="customMenuFormVisible" :title="i18nRender('layouts.customscene', [customMenuFormData ? $t('layouts.edit') : $t('layouts.new')])" width="820px" wrapClassName="custom-form" destroyOnClose>
      <template slot="footer">
        <div style="float:left;color:#252B3A;font-size:12px;line-height:32px;">
          {{ i18nRender('form-modal.selected') }}
          <span style="color:#C7000B;">{{ selectMenusLength }}</span>
          {{ i18nRender('form-modal.action') }}
        </div>
        <a-button key="cancel" :disabled="loading" @click="handleCustomMenuFormCancel">
          {{ i18nRender('form-modal.cancel') }}
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleCustomMenuFormSubmit">
          {{ i18nRender('form-modal.submit') }}
        </a-button>
      </template>
      <custom-menu-form
        ref="customMenuForm"
        :menus="visibleMenus"
        :form-data="customMenuFormData"
        :select-menus-length.sync="selectMenusLength"
        :currentLang="currentLang"
      />
    </a-modal>
    <!-- 首屏未读公告 -->
    <information-up v-if="initPanesFlag" />
    <!-- 店铺授权弹框 -->
    <!-- v-if="!ownStore && !isDemo" -->
    <store-authorize-tip v-if="!ownStore && !isDemo"></store-authorize-tip>
  </component>
</template>

<script>
import md5 from 'md5'
import { mapGetters } from 'vuex'
import { Modal } from 'ant-design-vue/es'
import EntryLayout from '@/components/EntryLayout'
import EntryLayout2 from '@/components/EntryLayout2'
import informationUp from '@/components/Tips/informationUp'
import RightContent from '@/components/GlobalHeader/RightContent'
import CustomMenuForm from '@/components/FormModal/CustomMenuForm'
import { ACCESS_TOKEN, STORE_AUTHORIZATION_NO_DISPLAY, USER_INFO } from '@/store/mutation-types'
import { filterPane, findPane } from '@/store/_util/util'
import { i18nRender } from '@/locales'
import { microAppsMixin } from '@/config/microApps.config'
import StoreAuthorizeTip from '@/components/Tips/storeAuthorizeTip.vue'

export default {
  name: 'BasicLayout',
  components: {
    EntryLayout,
    EntryLayout2,
    RightContent,
    CustomMenuForm,
    informationUp,
    StoreAuthorizeTip
  },
  mixins: [microAppsMixin],
  data () {
    const token = this.$ls.get(ACCESS_TOKEN)
    const subjectMode = this.$ls.get(USER_INFO)?.subjectMode
    const subjectCodeEncrypt = this.$ls.get(USER_INFO)?.subjectCodeEncrypt

    return {
      token,
      subjectMode,
      subjectCodeEncrypt,
      customMenuFormVisible: false,
      customMenuFormData: null,
      loading: false,
      selectMenusLength: 0,
      customTabs: [[], []],
      initPanesFlag: false
    }
  },
  computed: {
    ...mapGetters([
      'serviceId',
      'systemCode',
      'microApps',
      'menus',
      'visibleMenus',
      'customMenus',
      'menusActiveID',
      'panes',
      'iframes',
      'panesHistory',
      'activeKey',
      'currentLang',
      'unfold',
      'favorites',
      'useNewMenu',
      'ownStore',
      'isDemo'
    ]),
    layout () {
      const {
        useNewMenu
      } = this
      return useNewMenu === 1 ? 'EntryLayout' : 'EntryLayout2'
    }
  },
  watch: {
    activeKey: {
      handler: 'activeKeyWatcher',
      immediate: false
    },
    menusActiveID: {
      handler: 'getCustomTabs',
      immediate: true
    },
    '$route.params.name': {
      handler: 'loadMicroApp',
      immediate: false
    },
    layout: {
      handler: 'refreshMircoApps',
      immediate: false
    }
  },
  methods: {
    i18nRender,
    iframeUrl (iframe) {
      let menuUrl = window.location.protocol === 'https:' ? iframe.menuUrl.replace(/^http:/, 'https:') : iframe.menuUrl
      let whiteList = [
        'https://home.eccang.com/#/authformpage',
        'https://home.eccang.com/#/oauthpage',
        'https://home.eccang.com/#/shopsetpage',
        'https://home.eccang.com/#/authorization'
      ]
      if (whiteList.includes(menuUrl) && this.isDemo) {
        menuUrl = menuUrl.replace('https://home.eccang.com', window.location.protocol + process.env.VUE_APP_DEMO_URL)
      }
      const params = Object.keys(iframe.menuParams || {}).reduce((acc, key) => (acc + '&' + key + '=' + iframe.menuParams[key]), '')
      return `${menuUrl}${~iframe['menuUrl'].indexOf('?') ? '&' : '?'}resource=sso&token=${this.token}&subjectCodeEncrypt=${this.subjectCodeEncrypt}&LANGUAGE=${this.currentLang}${params}`
    },
    activeKeyWatcher (activeKey) {
      const { serviceId, systemCode, menusActiveID, panesHistory } = this
      const min = 8
      const max = 15 // tabs最多截取15

      if (activeKey === 'home') {
        history.pushState(null, null, `/entry/${serviceId}/${systemCode}`)
      }

      if (menusActiveID === '__HISTORY__') {
        this.customTabs = [
          panesHistory.slice(0, min),
          panesHistory.slice(min, max)
        ]
      }
    },
    getCustomTabs (key) {
      const { menus: systemMenus, customMenus, panesHistory } = this
      const min = 8
      const max = 15 // tabs最多截取15
      const customTabs = []
      const activeMenu = key && (
        systemMenus.find(menu => key === menu.key) ||
        customMenus.find(menu => key === menu.key)
      )
      if (key === '__HISTORY__') {
        customTabs.push(...panesHistory)
      } else if (activeMenu) {
        const tabs = filterPane(activeMenu.childMenus, { lastMenu: 2 })
        customTabs.push(...tabs)
      }

      this.customTabs[0] = customTabs.slice(0, min)
      this.customTabs[1] = customTabs.slice(min, max)
    },
    savePanes () {
      this.$store.dispatch('entry/SavePanes')
    },
    message (e) {
      const { method, data } = e.data
      const { serviceId, systemCode, activeKey } = this

      switch (method) {
        case 'getData': {
          const dataList = {
            'USER_INFO': this.$ls.get(USER_INFO)
          }
          const result = typeof data === 'string' ? dataList[data] : data.map(item => dataList[item])
          e.source.postMessage({ resource: 'sso', data: result }, e.origin)
          break
        }
        case 'authSuccess': {
          this.$ls.set(STORE_AUTHORIZATION_NO_DISPLAY, true)
          break
        }
        case 'noPermissionNotice': {
          this.$store.dispatch('entry/Navigator', {
            // ...data,
            tab: data?.tab || '无权限访问',
            key: 'entry401',
            path: `/entry/${serviceId}/${systemCode}/401`,
            noCache: false
          })
          break
        }
        case 'notification': {
          const { type, ...config } = data
          this.$notification[type](config)
          break
        }
        case 'navigator': {
          const { key, path } = data
          this.$store.dispatch('entry/Navigator', {
            ...data,
            systemDomain: path,
            menuUrl: path,
            path: `/entry/${serviceId}/${systemCode}/iframe#${key}`,
            noCache: true
          })
          break
        }
        case 'closeNavigator': {
          const { key, menusId } = data
          const closePaneKey = key || (menusId && `m_${menusId}`) || activeKey
          this.$store.dispatch('entry/ClosePane', closePaneKey)
          break
        }
        case 'navigatorErp': {
          let { key, path, ...other } = data
          path = /^(http:|https:)/.test(path) ? path : window.location.protocol + (/^(\/\/)/.test(path) ? path : `//${path}`)
          const newKey = key + md5(path)
          const newData = {
            ...other,
            key: newKey,
            systemDomain: path,
            menuUrl: path,
            path: `/entry/${serviceId}/${systemCode}/iframe#${newKey}`,
            noCache: true
          }
          this.$store.dispatch('entry/Navigator', newData)
          break
        }
        case 'dialog': {
          this.$dialog.iframe(data)
          break
        }
        case 'destroyAllDialog': {
          Modal.destroyAll()
          break
        }
        case 'openPageByMenusId': { // 选中菜单
          const { activeMenusId } = data
          this.$store.dispatch('entry/SetActiveKey', { key: `m_${activeMenusId}` })
          break
        }
        case 'logout': {
          this.$store.dispatch('Logout')
          break
        }
        case 'windowOpen': {
          const URL = data.url
          /**
           * @params name - 指定target属性或窗口的名称,[_blank, _parent, _self, _top]
           * @value _blank - URL加载到一个新的窗口。默认
           * @value _parent - URL加载到父框架
           * @value _self - URL替换当前页面
           * @value _top - URL替换任何可加载的框架集
           */
          const name = data.name || '_blank'
          window.open(URL, name)
          break
        }
      }
    },
    handleMenusChange (key) {
      this.$store.commit('entry/SET_MENUS_ACTIVE_ID', key)
    },
    /**
     * 打开tab菜单
     * @param[obj] - Object
     * @value obj.key - menuId
     * @value obj.statisticsType - 搜索类型（选填）「 1: 搜索, 2: 点击, 3: 最近打开 」
     * @value obj.searchKey - 搜索关键字（选填）
     */
    handleMenuChange (obj) {
      this.$store.dispatch('entry/SetActiveKey', obj)
    },
    handleCustomMenuAdd () {
      this.customMenuFormVisible = true
      this.customMenuFormData = null
      this.selectMenusLength = 0
    },
    handleCustomMenuRemove (menuInfo) {
      const { menuId } = menuInfo
      this.$confirm({
        title: '确认删除自定义菜单？',
        content: '点击确认将无法恢复数据，请谨慎选择。',
        okText: this.$t('form-modal.delete'),
        okButtonProps: {
          props: { type: 'danger' }
        },
        cancelText: this.$t('form-modal.cancel'),
        onOk: () => {
          this.$store
            .dispatch('entry/RemoveCustomMenu', menuId)
        }
      })
    },
    handleCustomMenuEdit (menuInfo) {
      this.selectMenusLength = 0

      this.customMenuFormVisible = true
      this.customMenuFormData = {
        groupId: menuInfo.menuId,
        customMenuName: menuInfo.tab,
        menuIds: menuInfo.childMenus.map(item => item.menuId),
        remark: menuInfo.remark
      }
    },
    handleCustomMenuFormCancel () {
      this.customMenuFormVisible = false
    },
    async handleCustomMenuFormSubmit () {
      const { customMenuForm } = this.$refs
      this.loading = true

      try {
        const formData = await customMenuForm.handleSubmit()

        if (formData.groupId) {
          await this.$store.dispatch('entry/EditCustomMenu', formData)
        } else {
          await this.$store.dispatch('entry/AddCustomMenu', formData)
        }

        this.customMenuFormVisible = false
        this.getCustomTabs(this.menusActiveID)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error?.message)
      }

      this.loading = false
    },
    handleMenuPushpin (e) {
      this.$store.dispatch('entry/PushpinMenu', e)
    }
  },
  mounted () {
    const { message, loadMicroApp, loadedMicroApps, unmountMircoApp, savePanes } = this
    const {
      fullPath: activePath,
      params: { serviceId, systemCode, name },
      query: { tab }
    } = this.$route
    window.addEventListener('beforeunload', savePanes.bind(this))
    window.addEventListener('message', message.bind(this))

    this.$store.dispatch('entry/InitPanes', { serviceId, systemCode, activePath })
      .then(() => {
        if (tab) {
          const found = findPane(this.$store.state.entry.menus, { tab, lastMenu: 2 })
          // console.log('found', found)
          this.$store.dispatch('entry/CloseAllPane')
          this.$store.dispatch('entry/SetActiveKey', found?.key ? { key: found.key } : { tab, key: -1 })
          // this.$store.dispatch('entry/SetActiveKey', found || { tab, key: -1 })
        }
        this.initPanesFlag = true
        name && loadMicroApp(name)
      })
    this.$once('hook:destroyed', () => {
      window.removeEventListener('beforeunload', savePanes.bind(this))
      window.removeEventListener('message', message.bind(this))
      Object.keys(loadedMicroApps).map(cacheKey => unmountMircoApp.bind(this, cacheKey))
    })
  }
}
</script>

<style>
#app-view-box {
  flex: 1;
  overflow: auto;
}

#sso-web-view-box, div[data-name=sso-web] {
  height: 100%;
}

.entry-layout-sider.ant-layout-sider {
  background: #ffffff;
}

.custom-form .ant-checkbox-group {
  display: block;
}
.custom-form .ant-modal-body {
  max-height: 70vh;
  overflow: auto;
}
.custom-form .ant-modal-footer {
  background-color: #FAFAFA;
}
</style>
